import {BrowserTabsMessageType} from '@toolify/client/src/modules/broadcast/enum/BrowserTabsMessageType'
import {IBrowserTabState} from '@toolify/client/src/modules/broadcast/types/IBrowserTabState'
import {TBrowserTabsMessage} from '@toolify/client/src/modules/broadcast/types/TBrowserTabsMessage'

function isTabId(value: unknown): value is string {
  return typeof value === 'string' && value.length > 0
}

export function isBrowserTabState(value: unknown): value is IBrowserTabState {
  if(!value || typeof value !== 'object') {
    return false
  }
  const state = value as IBrowserTabState
  return isTabId(state.tabId)
    && Number.isFinite(state.openedAt)
    && Number.isFinite(state.lastActiveAt)
    && Number.isFinite(state.updatedAt)
    && typeof state.isVisible === 'boolean'
    && typeof state.isFocused === 'boolean'
}

export function isBrowserTabsMessage(value: unknown): value is TBrowserTabsMessage {
  if(!value || typeof value !== 'object') {
    return false
  }
  const message = value as TBrowserTabsMessage
  if(message.type === BrowserTabsMessageType.Bye) {
    return isTabId(message.tabId)
  }
  if(message.type === BrowserTabsMessageType.Hello || message.type === BrowserTabsMessageType.State) {
    return isBrowserTabState(message.state)
  }
  return false
}
